import { TenantOTALayout } from "../../../../TenantProfile"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<TenantOTALayout>
			<Outlet />
		</TenantOTALayout>
	)
}
